<div class="ttmodal" id="schematicWindow" >
    <div id="schematicWindowHeader" class="ttmodal__header">
        <span class="ttmodal__title">{{title}}</span>
        <div class="panel__header__button-container" id="closeButton">
            <a class="button waves-effect" (click)="onCloseClick()">
                <i class="material-icons button__icon">cancel</i>
                <span class="button__text">Close</span>
            </a>
        </div>
    </div>

    <div class="ttmodal__body">
        <div *ngIf="schematic != null" style="width: auto; height: auto; position: relative; margin-left: 2px;">
            <img [src]="getImage(schematic.Data)" style="width: 100%; height: 100%;" (click)="openObservationPointModal($event)"> 
            <ng-container *ngIf="schematic.GETComponents != null">
                <ng-container *ngFor="let cp of schematic.GETComponents">
                    <i class="material-icons button__icon component-dot"
                       [class.green-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'green'"
                       [class.yellow-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'"
                       [class.orange-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'orange'"
                       [class.red-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'red'"
                       [class.no-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'gray'"
                       [class.component-dot2]="mouseoverMPId == cp.Id"
                       (mouseover)="onMouseOverMP(cp.Id)" (mouseout)="onMouseOutMP(cp.Id)"
                       matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}}"
                       [style]="getPosition(cp.PositionX, cp.PositionY)" >lens</i>
                     
                </ng-container>

                <ng-container *ngFor="let op of schematic.ObservationPoints">
                    <i class="material-icons button__icon component-dot"
                       [class.green-eval]="getEval(op.WornPct, op.InspectionDate) == 'green'"
                       [class.yellow-eval]="getEval(op.WornPct, op.InspectionDate) == 'yellow'"
                       [class.orange-eval]="getEval(op.WornPct, op.InspectionDate) == 'orange'"
                       [class.red-eval]="getEval(op.WornPct, op.InspectionDate) == 'red'"
                       [class.no-eval]="getEval(op.WornPct, op.InspectionDate) == 'gray'"
                       [class.component-dot2]="mouseoverOPId == op.Id"
                       (mouseover)="onMouseOverOP(op.Id)" (mouseout)="onMouseOutOP(op.Id)"
                       matTooltip="{{op.Name}} ({{op.WornPct}}% Worn) Last Inspection - {{op.InspectionDate}}"
                       [style]="getPosition(op.PositionX, op.PositionY)">lens</i>
                       
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>



